import { cn } from '../../lib/cn';

const VARIANT_STYLES = {
  default: {
    background: 'var(--dash-surface-subtle)',
    color: 'var(--dash-text-soft)',
    border: '1px solid var(--dash-border)',
  },
  primary: {
    background: 'var(--dash-primary-soft)',
    color: 'var(--dash-primary)',
    border: '1px solid var(--dash-primary-border)',
  },
  success: {
    background: 'rgba(52, 254, 173, 0.10)',
    color: '#1fb37c',
    border: '1px solid rgba(52, 254, 173, 0.25)',
  },
  warning: {
    background: 'rgba(254, 173, 52, 0.10)',
    color: '#c47b00',
    border: '1px solid rgba(254, 173, 52, 0.25)',
  },
  danger: {
    background: 'rgba(254, 52, 86, 0.10)',
    color: '#d61f3f',
    border: '1px solid rgba(254, 52, 86, 0.25)',
  },
  info: {
    background: 'rgba(52, 173, 254, 0.10)',
    color: '#1f7bb3',
    border: '1px solid rgba(52, 173, 254, 0.25)',
  },
  muted: {
    background: 'transparent',
    color: 'var(--dash-text-muted)',
    border: '1px solid var(--dash-border)',
  },
};

export function Badge({
  className,
  variant = 'default',
  children,
  icon: Icon,
  dot,
  style,
  ...props
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[10px] font-medium uppercase tracking-[0.08em]',
        className
      )}
      style={{ ...VARIANT_STYLES[variant], ...style }}
      {...props}
    >
      {dot && (
        <span
          className="h-1.5 w-1.5 rounded-full"
          style={{ background: 'currentColor' }}
        />
      )}
      {Icon && <Icon size={11} strokeWidth={2.4} />}
      {children}
    </span>
  );
}
